import PageHeader from "../Components/pageHeader"

export default function Contact() {
    return (
        <>
        <PageHeader title="Contact"/>
        </>
    )
}